import React, { Component } from "react";
import { Spin, message, Table, Modal } from "antd";
import axios from "axios";
import URLs from "../../utils/apis";

export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      input_placeholder: "",
      loading: false,
      listLoader: false,
      image: "",
      mission_list: [],

      add_modal_status: false,
      service_name: "",
      service_description: "",
      short_description: "",
      service_image: "",
      icon_img: "",
      formloader: false,

      mission_id: 0,
      edit_modal_status: false,
      edit_service_name: "",
      edit_service_description: "",
      edit_short_description: "",
      edit_service_image: "",
      edit_icon_img: "",
      service_image_url: "",
      is_image_present: false,

      delete_modal_status: false,
    };
  }
  componentDidMount() {
    this.get_mission_list();
  }
  get_mission_list = () => {
    this.setState({ listLoader: true });
    axios
      .get(URLs.get_mission_list)
      .then((response) => {
        if (response.data.status == "1") {
          let currentObj = response.data.data;
          this.setState({
            mission_list: response.data.data,
            listLoader: false,
          });
        } else {
          this.setState({ listLoader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ listLoader: false });
      });
  };
  save_service = () => {
    if (!this.state.service_name) {
      message.warning("Service name is required");
      return;
    }
    if (!this.state.short_description) {
      message.warning("Short Service description is required");
      return;
    }
    if (!this.state.service_description) {
      message.warning("Long Service description is required");
      return;
    }
    if (!this.state.service_image) {
      message.warning("Please select Service image");
      return;
    }
    if (!this.state.icon_img) {
      message.warning("Please select Icon for service");
      return;
    }
    this.setState({ formloader: true });
    let formData = new FormData();
    formData.append("name", this.state.service_name);
    formData.append("description", this.state.service_description);
    formData.append("short_description", this.state.short_description);
    formData.append("service_image", this.state.service_image);
    formData.append("icon_img", this.state.icon_img);
    axios
      .post(URLs.save_service, formData)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              formloader: false,
              service_name: "",
              service_description: "",
              short_description: "",
              add_modal_status: false,
              service_image: "",
              icon_img: "",
            },
            () => this.get_mission_list()
          );
        } else {
          message.warning(response.data.message);
          this.setState({ formloader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ formloader: false });
        console.error("Warning:", error);
        // message.warning("Please try again.");
      });
  };
  open_add_modal = () => {
    this.setState({
      add_modal_status: true,
      service_name: "",
      service_description: "",
      service_image: "",
    });
  };
  close_save_modal = () => {
    this.setState({
      add_modal_status: false,
      service_name: "",
      service_description: "",
      service_image: "",
    });
  };
  open_edit_modal = (item) => {
    let url = URLs.image_url + item.image;
    this.setState({
      edit_modal_status: true,
      title: item.title,
      description: item.description,
      image_url: url,
      mission_id: item.id,
      is_image_present: item.image ? true : false,
    });
  };
  close_update_modal = () => {
    this.setState({
      edit_modal_status: false,
      title: "",
      description: "",
      image_url: "",
      mission_id: "",
      is_image_present: false,
    });
  };
  update_mission = () => {
    if (!this.state.title) {
      message.warning("Title is required");
      return;
    }
    if (!this.state.description) {
      message.warning("Description is required");
      return;
    }
    this.setState({ formloader: true });
    let formData = new FormData();
    formData.append("title", this.state.title);
    formData.append("description", this.state.description);
    formData.append("image", this.state.image);
    formData.append("mission_id", this.state.mission_id);
    axios
      .post(URLs.save_mission_record, formData)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              formloader: false,
              title: "",
              description: "",
              edit_modal_status: false,
              image: "",
              mission_id: 0,
            },
            () => this.get_mission_list()
          );
        } else {
          message.warning(response.data.message);
          this.setState({ formloader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ formloader: false });
        console.error("Warning:", error);
      });
  };
  close_delete_modal = () => {
    this.setState({
      delete_modal_status: false,
      mission_id: "",
    });
  };
  open_delete_modal = (item) => {
    this.setState({
      delete_modal_status: true,
      mission_id: item.mission_id,
    });
  };
  delete_service = () => {
    let params = {
      mission_id: this.state.mission_id,
    };
    axios
      .post(URLs.delete_service, params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              formloader: false,
              delete_modal_status: false,
              mission_id: 0,
            },
            () => this.get_mission_list()
          );
        } else {
          message.warning(response.data.message);
          this.setState({ formloader: false });
          return;
        }
      })
      .catch((error) => {
        this.setState({ formloader: false });
        console.error("Warning:", error);
      });
  };
  render() {
    const columns = [
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        width: 150,
      },
      {
        title: "Description",
        dataIndex: "desc",
        key: "desc",
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        render: (item) => {
          return (
            <div>
              <button
                type="button"
                onClick={() => this.open_edit_modal(item)}
                class="btn btn-primary mb-3"
                style={{ width: 50, height: 35 }}
              >
                <box-icon
                  name="edit-alt"
                  color="#ffffff"
                  size={"18px"}
                ></box-icon>
              </button>
            </div>
          );
        },
      },
    ];
    const dataSource = this.state.mission_list.map((item, index) => {
      return {
        title: item.title ? item.title : "---",
        desc: item.description ? item.description : "---",
        action: item,
      };
    });
    return (
      <div class="card">
        <div class="card-header">
          <h4 class="card-title" style={{ fontSize: 16, marginBottom: 0 }}>
            Mission & Vision
          </h4>
        </div>
        <Spin spinning={this.state.loading}>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-lg-12">
                <div class="card mt-3 p-3">
                  <Table
                    bordered
                    loading={this.state.listLoader}
                    dataSource={dataSource}
                    columns={columns}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>

        {/* Edit Service Modal  */}
        <Modal
          title="Update Mission & Vision"
          visible={this.state.edit_modal_status}
          onOk={() => this.update_mission()}
          onCancel={() => this.close_update_modal()}
          okText="Update"
          cancelText="Cancel"
        >
          <Spin spinning={this.state.formloader}>
            <div class="py-4">
              <div class="mb-3">
                <label for="example-text-input" class="form-label">
                  Title <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  value={this.state.title}
                  onChange={(e) => this.setState({ title: e.target.value })}
                />
              </div>
              <div class="mb-3">
                <label for="example-search-input" class="form-label">
                  Description <span class="text-danger">*</span>
                </label>
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder=""
                  name="detail"
                  id="detail"
                  spellcheck="false"
                  value={this.state.description}
                  onChange={(e) =>
                    this.setState({ description: e.target.value })
                  }
                ></textarea>
              </div>

              <div class="mb-3">
                <label for="example-text-input" class="form-label">
                  Image
                </label>
                {this.state.is_image_present == true && (
                  <div
                    style={{
                      padding: 10,
                      border: "1px solid #ddd",
                      width: "fit-content",
                    }}
                    class="mb-2"
                  >
                    <a href={this.state.image_url} target="_blank">
                      <img src={this.state.image_url} style={{ width: 100 }} />
                    </a>
                  </div>
                )}
                <input
                  class="form-control"
                  type="file"
                  onChange={(e) => this.setState({ image: e.target.files[0] })}
                />
              </div>
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
}
